import { render } from "./QuizHome.vue?vue&type=template&id=c6fc2608&scoped=true"
import script from "./QuizHome.vue?vue&type=script&lang=js"
export * from "./QuizHome.vue?vue&type=script&lang=js"

import "./QuizHome.vue?vue&type=style&index=0&id=c6fc2608&scoped=true&lang=css"

import exportComponent from "/var/www/mobitel/quizgiri/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6fc2608"]])

export default __exports__